export const TRANSACTIONS_TYPES = [
    "Buy",
    "Sell",
    "Swap",
    "Deposit",
    "Withdraw",
    "Unknown",
    "Reward",
    "Unwrap",
    "Wrap",
    "Approve",
    "Stake",
    "Unstake",
    "Gift",
    "Other",
];
export const MANUAL_TX_TYPES = ["Swap", "Deposit", "Withdraw", "Gift", "Other"];
export const TRADE_TYPES = [
    "Long",
    "Short",
    // "Borrow"
];
export const DEFAULT_POLLING_INTERVAL = 2_000;
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["Queued"] = "queued";
    TaskStatus["Running"] = "running";
    TaskStatus["Completed"] = "completed";
    TaskStatus["Aborted"] = "aborted";
    TaskStatus["Cancelled"] = "cancelled";
    TaskStatus["Failed"] = "failed";
})(TaskStatus || (TaskStatus = {}));
export var SubscriptionChannel;
(function (SubscriptionChannel) {
    SubscriptionChannel["Accounts"] = "accounts";
    SubscriptionChannel["ServerTasks"] = "server-tasks";
    SubscriptionChannel["ServerTaskProgress"] = "server-task-progress";
    SubscriptionChannel["ServerFiles"] = "server-files";
    SubscriptionChannel["KeyValue"] = "key-value";
    SubscriptionChannel["AuditLogs"] = "audit-logs";
    SubscriptionChannel["ChatHistory"] = "chat-history";
    SubscriptionChannel["Networth"] = "networth";
    SubscriptionChannel["DailyPrices"] = "daily-prices";
    SubscriptionChannel["FileImports"] = "file-imports";
    SubscriptionChannel["Connections"] = "connections";
    SubscriptionChannel["Metadata"] = "metadata";
    SubscriptionChannel["Balances"] = "balances";
    SubscriptionChannel["Transactions"] = "transactions";
    SubscriptionChannel["ServerLog"] = "server-logs";
    SubscriptionChannel["Tags"] = "tags";
    SubscriptionChannel["Trades"] = "trades";
    SubscriptionChannel["TradePnl"] = "trade-pnl";
    SubscriptionChannel["Notifications"] = "notifications";
})(SubscriptionChannel || (SubscriptionChannel = {}));
export var EventCause;
(function (EventCause) {
    EventCause["Created"] = "created";
    EventCause["Updated"] = "updated";
    EventCause["Deleted"] = "deleted";
    EventCause["Reset"] = "reset";
})(EventCause || (EventCause = {}));
export var TaskPriority;
(function (TaskPriority) {
    TaskPriority[TaskPriority["Lowest"] = 1] = "Lowest";
    TaskPriority[TaskPriority["VeryLow"] = 2] = "VeryLow";
    TaskPriority[TaskPriority["Low"] = 3] = "Low";
    TaskPriority[TaskPriority["MediumLow"] = 4] = "MediumLow";
    TaskPriority[TaskPriority["Medium"] = 5] = "Medium";
    TaskPriority[TaskPriority["MediumHigh"] = 6] = "MediumHigh";
    TaskPriority[TaskPriority["High"] = 7] = "High";
    TaskPriority[TaskPriority["VeryHigh"] = 8] = "VeryHigh";
    TaskPriority[TaskPriority["Highest"] = 9] = "Highest";
})(TaskPriority || (TaskPriority = {}));
//# sourceMappingURL=interfaces.js.map